import React from 'react';

const AudioComponent = ({ stream }) => {
  return (
    <>
      <audio
        ref={(el) => {
          if (el && stream) el.srcObject = stream;
        }}
        autoPlay
      ></audio>
    </>
  );
};

export default React.memo(AudioComponent);
